import { render, staticRenderFns } from "./GlobalNotify.vue?vue&type=template&id=9aa25bb6&scoped=true&"
import script from "./GlobalNotify.vue?vue&type=script&lang=js&"
export * from "./GlobalNotify.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNotify.vue?vue&type=style&index=0&id=9aa25bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa25bb6",
  null
  
)

export default component.exports